import { render, staticRenderFns } from "./operationLog.vue?vue&type=template&id=0b887c42&scoped=true&"
import script from "./operationLog.vue?vue&type=script&lang=js&"
export * from "./operationLog.vue?vue&type=script&lang=js&"
import style0 from "./operationLog.vue?vue&type=style&index=0&id=0b887c42&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b887c42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b887c42')) {
      api.createRecord('0b887c42', component.options)
    } else {
      api.reload('0b887c42', component.options)
    }
    module.hot.accept("./operationLog.vue?vue&type=template&id=0b887c42&scoped=true&", function () {
      api.rerender('0b887c42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/client/customer/detail/operationLog.vue"
export default component.exports